import { createContext, useContext, useState } from "react";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (en) => en,
});

export const useLanguage = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const t = (en, gu) => (lang === "en" ? en : gu);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
